export default function ChaseIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="39.999" height="39.999" rx="8" fill="white" />
      <path
        d="M16.0002 6C15.4119 6 15.059 6.47059 15.059 6.94117V13.8823H33.4119L25.059 6H16.0002Z"
        fill="#126BC5"
      />
      <path
        d="M34 16.0002C34 15.412 33.5294 15.059 33.0588 15.059H26.1177V33.4119L34 25.059V16.0002Z"
        fill="#126BC5"
      />
      <path
        d="M23.9999 34C24.5882 34 24.9411 33.5294 24.9411 33.0588V26.1177H6.58824L14.9411 34H23.9999Z"
        fill="#126BC5"
      />
      <path
        d="M6 24C6 24.5883 6.47059 24.9412 6.94118 24.9412H13.8823V6.70599L6 15.0589V24Z"
        fill="#126BC5"
      />
    </svg>
  );
}
